import Vue from "vue";
import windowsSizes from "@/config/window-sizes";

import { deleteCookie } from "@/utils";

const vue = Vue;

export default {
  SET_SETTINGS(state, value) {
    Vue.set(state, "settings", value);
  },
  SET_LANGUAGE(state, value) {
    state.locale = value;
  },
  SET_THEME(state, value) {
    state.theme = value;
  },
  SET_DEFAULT_PATH(state, value) {
    state.defaultPath = value;
  },
  CLEAR_USER_DATA(state) {
    state.datasources = {};
    state.objectInfo = {};
    state.objectFields = {};
    state.user_config = {
      datasources: {},
      objectInfoFields: {},
      timeFormat: "DD-MM-YYYY HH:mm:ss",
      baselayerId: 5
    };
    state.leftPanelLinks = [];
    state.interface.windowsConfigs = [];
    state.interface.desktop = [];
    state.interface.overheadLayout = [];
    state.auth.token = undefined;
    state.auth.user = undefined;
    state.dsTreeState.dsTree = [];
    state.commonData.filteredFields = [];
    deleteCookie("token");
  },
  RESET_USER_CONFIG(state, options) {
    if (options.find(e => e === "Book")) {
      state.book.activeTable.id = null;
      state.book.activeTable.source_id = null;
      state.book.activeTable.name = null;
      state.book.activeTable.geomType = null;
      state.book.activeTable.dataLength = null;
    }
    if (options.find(e => e === "Chart")) {
      state.charts.chartsLayouts = {};
      state.charts.openedCharts = {};
    }
    if (options.find(e => e === "Map")) {
      state.map.styleConfig = {};
      state.map.requestedFields = null;
      state.map.activeLayers = [];
      state.map.styleConfig = null;
      state.map.objectFieldsConfigs = null;
      state.user_config = {
        baselayerId: 5,
        biBaselayerId: 5
      };
    }
    if (options.find(e => e === "Windows")) {
      state.interface.desktop = [];
      state.interface.overheadLayout = [];
      state.interface.windowsConfigs = [];
      state.interface.sizesConfig = null;
    }

    state.book.treeExpandedNodes = null;
    state.book.treeScrollNode = null;

    state.smartObjectInfo = {
      activeCards: {
        si_centre: []
      },
      activeCard: {
        si_centre: null
      },
      flyTo: {
        si_centre: {}
      }
    };

    state.dsTreeState = {
      dsTree: [],
      changed: false
    };
    state.user_config = {
      datasources: {},
      objectInfoFields: {},
      timeFormat: "DD-MM-YYYY HH:mm:ss",
      pageSize: {
        book: 10,
        userRoles: 10
      }
    };
    state.theme = null;
    state.local = null;
    state.defaultPath = null;
  },
  SAVE_DATASOURCE_SETTINGS(state, { id, field, settings, popup }) {
    state.user_config.datasources[id] = {
      [field]: settings,
      popup
    };
  },
  SET_DATASOURCE(state, data) {
    data.forEach(l => {
      state.datasources[l.id] = l;
      if (l.children && l.children.length) {
        l.children.forEach(ch => {
          state.datasources[ch.id] = ch;
        });
      }
    });
    state.dsTreeState.dsTree = data;
    state.isReadyToRender = true;
  },
  SET_DATASOURCES_FROM_CONFIG(state, payload) {
    state.datasources = payload;
  },
  ADD_DATASOURCES(state, data) {
    Object.keys(data).forEach(id => {
      state.datasources[id] = data[id];
      if (data[id].parent_id) {
        const layer = state.dsTreeState.dsTree.find(
          l => l.id === data[id].parent_id
        );
        if (layer) layer.children.push({ id, children: [] });
      } else {
        state.dsTreeState.dsTree.push({ id, children: [] });
      }
    });
    state.dsTreeState.changed = !state.dsTreeState.changed;
  },
  DELETE_DATASOURCES(state, { ids }) {
    ids.forEach(id => {
      delete state.datasources[id];
      const findLayer = children => {
        for (let i = 0; i < children.length; i++) {
          if (children[i].id === id || children[i].source_id === id) {
            children.splice(i, 1);
            i--;
            continue;
          }
          if (children[i].children && children[i].children.length)
            findLayer(children[i].children);
        }
      };
      findLayer(state.dsTreeState.dsTree);
    });
    state.dsTreeState.changed = !state.dsTreeState.changed;
  },
  UPDATE_DATASOURCES(state, data) {
    Object.keys(data).forEach(id => {
      const initial = state.datasources[id];
      if (initial) initial.name = data[id].name;
    });
    state.dsTreeState.changed = !state.dsTreeState.changed;
  },
  SET_MAIN_CONFIG(state, main_config) {
    console.log("main_config", main_config);
    main_config.DataSource.forEach(l => {
      state.datasources[l.id] = l;
      if (l.children && l.children.length) {
        l.children.forEach(ch => {
          state.datasources[ch.id] = ch;
        });
      }
    });
    main_config.DataSource.forEach(l => {
      state.dsTreeState.dsTree.push({
        id: l.id,
        children: !l.children
          ? []
          : l.children.map(ch => ({ id: ch.id, children: [] }))
      });
    });
    state.isReadyToRender = true;
  },
  SET_USER_CONFIG(state, { user_config, user }) {
    console.log("user_config", user_config);
    if (user) {
      state.admin = user.admin;
      state.local_admin = user.local_admin;
    }
    state.instance = user_config.instance || "dev";
    state.userId = user_config.user_id || "";
    state.locale = user_config.locale || "ru";
    state.theme = user_config.theme || "dark-theme";
    state.defaultPath = user_config.default_path || "/app/map";
    state.interface.windowsConfigs = user_config.windows_configs
      ? user_config.windows_configs
      : [];

    if (user_config.desktops && user_config.desktops.overheadLayout) {
      const clientHeight = document.body.clientHeight;
      const clientWidth = document.body.clientWidth;

      user_config.desktops.overheadLayout.map(e => {
        if (e.h > clientHeight) e.h = clientHeight - 80;
        if (e.y < 0) e.y = 5;
        if (e.w + e.x > clientWidth) {
          let dif = e.w + e.x - clientWidth;

          e.x = e.x - dif - 5;
        }
      });

      state.interface.overheadLayout = user_config.desktops.overheadLayout;
    } else {
      state.interface.overheadLayout = [];
    }

    if (user_config.desktops) {
      state.interface.minimizedWindows = user_config.desktops.overheadLayout
        ? user_config.desktops.overheadLayout.filter(i => i.isMinimized)
        : [];
    }
    state.user_config.datasources = { ...user_config.datasources };
    state.user_config.objectInfoFields = { ...user_config.object_info_fields };
    if (user_config.ds_tree_expanded)
      state.dsTreeExpanded = user_config.ds_tree_expanded;
    if (user_config.charts && user_config.charts.charts_layouts) {
      state.charts.chartsLayouts = user_config.charts.charts_layouts;
    }
    if (user_config.charts && user_config.charts.opened_charts) {
      state.charts.openedCharts = user_config.charts.opened_charts;
    }
    if (user_config.map) {
      const {
        bi_baselayer_id,
        bi_style_config,
        bi_requested_fields,
        bi_object_fields_configs,
        activeLayers
      } = user_config.map;

      state.user_config.baselayerId = bi_baselayer_id
        ? Number(bi_baselayer_id)
        : 5;

      if (bi_style_config) state.map.styleConfig = bi_style_config;

      if (bi_requested_fields) state.map.requestedFields = bi_requested_fields;
      if (bi_object_fields_configs)
        state.map.objectFieldsConfigs = bi_object_fields_configs;
      if (activeLayers) state.map.initialActiveLayers = activeLayers;
    }
    if (!user_config.sizes_config) {
      state.interface.sizesConfig = windowsSizes;
    } else {
      state.interface.sizesConfig = user_config.sizes_config;
    }
    if (user_config.book) {
      state.book.activeTable.source_id = user_config.book.activeBook.source_id;
      state.book.activeTable.id = user_config.book.activeBook.id;
      state.book.activeTable.name = user_config.book.activeBook.name;
      state.book.activeTable.geomType = user_config.book.activeBook.geomType;
      state.book.activeTable.dataLength =
        user_config.book.activeBook.dataLength;
      state.profiles.treeExpandedNodes = user_config.book.treeExpandedNodes
        ? user_config.book.treeExpandedNodes
        : [];
      state.profiles.treeScrollNode = user_config.book.treeScrollNode
        ? user_config.book.treeScrollNode
        : "";
    }
    if (user_config.modelling) {
      state.modelling = user_config.modelling;
    }
    if (user_config.sit_center) {
      if (user_config.sit_center.disabledLayers) {
        state.situationCenter.disabledLayers =
          user_config.sit_center.disabledLayers;
      }
      if (user_config.sit_center.objectCard) {
        state.situationCenter.objectCard = user_config.sit_center.objectCard;
      }
      if (user_config.sit_center.layout) {
        state.situationCenter.layout = user_config.sit_center.layout;
      }
    }
    state.isReadyToRender = true;
  },
  SET_MODULE_CONFIG(state, { user_config, module }) {
    switch (module) {
      case "chart":
        if (user_config.charts && user_config.charts.charts_layouts) {
          state.charts.chartsLayouts = user_config.charts.charts_layouts;
        }
        if (user_config.charts && user_config.charts.opened_charts) {
          state.charts.openedCharts = user_config.charts.opened_charts;
        }
        break;
    }
    state.isReadyToRender = true;
  },
  SET_OBJECT_INFO(state, { source_id, data }) {
    vue.$clientStore.insertData(source_id, data);
  },
  SET_OBJECT_FIELDS(state, { source_id, fields }) {
    vue.$clientStore.setDataFields(source_id, fields);
  },
  UPDATE_OBJECT_INFO(state, { source_id, data }) {
    vue.$clientStore.updateData(source_id, data);
  },
  ADD_OBJECT_INFO(state, { source_id, data }) {
    vue.$clientStore.insertData(source_id, data);
  },
  DELETE_OBJECT_INFO(state, { source_id, ids }) {
    vue.$clientStore.deleteData(source_id, ids);
  },
  SET_BASELAYER_ID(state, id) {
    state.user_config.baselayerId = id;
  },
  INIT_CHART_LISTENER(state, { source_id }) {
    if (!source_id) {
      return;
    }
    const index = state.openedCharts.findIndex(item => item.id === source_id);
    if (index >= 0) {
      state.openedCharts[index].actual = true;
    } else {
      state.openedCharts.push({
        id: source_id,
        actual: true
      });
    }
  },
  REMOVE_CHART_LISTENER(state, payload) {
    const index = state.openedCharts.findIndex(
      item => item.id === payload.source_id
    );
    state.openedCharts.splice(index, 1);
  },
  SET_CHART_DATA(state, payload) {
    vue.$clientStore.insertData(payload.source_id, payload.data);
  },
  SET_CHART_PROPS(state, payload) {
    vue.$clientStore.setDataFields(payload.source_id, payload.fields);
  },
  UPDATE_CHART(state, { source_id }) {
    if (!source_id) {
      return;
    }
    const index = state.openedCharts.findIndex(item => item.id === source_id);
    if (index >= 0) {
      state.openedCharts[index].actual = false;
    } else {
      state.openedCharts.push({
        id: source_id,
        actual: false
      });
    }
  },
  ADD_TO_CHART(state, { source_id }) {
    if (!source_id) {
      return;
    }
    const index = state.openedCharts.findIndex(item => item.id === source_id);
    if (index >= 0) {
      state.openedCharts[index].actual = false;
    } else {
      state.openedCharts.push({
        id: source_id,
        actual: false
      });
    }
  },
  DELETE_FROM_CHART(state, { source_id }) {
    if (!source_id) {
      return;
    }
    const index = state.openedCharts.findIndex(item => item.id === source_id);
    if (index >= 0) {
      state.openedCharts[index].actual = false;
    } else {
      state.openedCharts.push({
        id: source_id,
        actual: false
      });
    }
  },
  ADD_ACTIVE_TASK(state, task) {
    state.activeTasks.push(task);
  },
  REMOVE_ACTIVE_TASK(state, task_id) {
    state.activeTasks = state.activeTasks.filter(t => t.task_id !== task_id);
  },
  SET_OBJECT_INFO_FIELDS(state, { source_id, fields }) {
    state.user_config.objectInfoFields[source_id] = fields;
  },
  SET_TIME_FORMAT(state, format) {
    state.user_config.timeFormat = format;
  },
  SET_ACTIVE_BASELAYER_ID(state, id) {
    state.user_config.baselayerId = id;
  },
  SAVE_DS_TREE(state, tree) {
    state.dsTree = tree;
  },
  SET_DS_TREE_PARAM(state, { field, value }) {
    state.dsTreeState[field] = value;
  },
  UPDATE_MAP(state, payload) {
    if (payload === "mapBIState") {
      state.map[payload].isMapResized = true;
    } else {
      state.map[payload].isMapResized = true;
    }
  },
  ADD_LISTENER_ID(state, id) {
    state.listeners.push(id);
  },
  SET_DATASOURCE_FROM_TREE(state, { data, id }) {
    state.datasources[id] = data;
  },
  // TODO: this is demo access for LTM Project - NEED TO DELETE
  SET_DEMO_GUEST(state) {
    state.demoGuest = true;
  }
};
